import { createAction } from '@reduxjs/toolkit';

import { Layers } from '../consts';

export const setMapLayerDownloaded = createAction<{
  layerName: Layers;
  version: number;
}>('SET_MAP_LAYER_DOWNLOADED');
